import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }

import { ref, defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'indexToasts',
  setup(__props) {

const basicToasts = defineAsyncComponent(() => import("@/components/theme/advance/toasts/basicToasts.vue"))
const iconToasts = defineAsyncComponent(() => import("@/components/theme/advance/toasts/iconToasts.vue"))
const positionToasts = defineAsyncComponent(() => import("@/components/theme/advance/toasts/positionToasts.vue"))

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "Bonus Ui",
      title: "Toasts"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(basicToasts)),
        _createVNode(_unref(iconToasts)),
        _createVNode(_unref(positionToasts))
      ])
    ])
  ], 64))
}
}

})